<template>
  <div class="details">

    <div class="top" :class="lang == 'ar' ? 'ar' : ''">
      <p class="nav_short" :class="lang == 'ar' ? 'arshort' : ''">
        <span class="back" @click="toForm"></span>
      </p>
      <p class="nav_long" :class="lang == 'ar' ? 'arlong' : ''"></p>
    </div>

    <div class="content">
      <div class="TextTitle" v-html="title"></div>
      <div class="textContent" v-html="content"></div>
    </div>
  </div>
</template>

<script>
import { agreement } from "@/proxy/index";

export default {
  data() {
    return {
      lang: "en",
      activity_tag: "",
      title: "",
      content: "",
    };
  },
  methods: {
    getParam() {
      agreement({ lang: this.lang })
        .then((res) => {
          if (res.code == 0) {
            var data = res.data.agreement;
            this.title = data.title;
            this.content = data.content;
            this.other_activity = data.other_activity;
          }
        })
        .catch(() => {
          //
        });
    },
    toForm() {
      this.$router.push({
        path: "/form",
        query: {
          activity_tag: this.activity_tag,
          lang: this.lang,
        },
      });
    },
  },
  created() {
    this.activity_tag = this.$route.query.activity_tag;
    this.lang = this.$route.query.lang;
  },
  mounted() {
    // if (this.$route.query) {
    //   this.$router.push({ query: {} });
    // }
    this.getParam();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/public.scss";

.details {
  min-height: 100vh;
  @include pb(105);
  box-sizing: border-box;

  .top {
    width: 100%;
    @include wh(0, 80);
    display: flex;

    .nav_long {
      @include wh(0, 80);
      @include ml(-10);
      @include bg("nav_back.png");
      flex: 1;
    }
    .nav_short {
      @include wh(113, 80);
      @include bg("return_back.png");
      .back {
        display: inline-block;
        @include wh(110, 80);
        @include bg("back.png");
      }
    }

    .arshort {
      transform: rotateY(180deg);
    }
    .arlong {
      @include mr(-10);
      transform: rotateY(180deg);
    }

    &.ar {
      direction: rtl;
      unicode-bidi: bidi-override;
      text-align: right;
    }
  }
  .content {
    @include pd(0, 32);
    color: #c6d9de;
    text-align: left;
    .TextTitle {
      border-bottom: 1px solid #314c69;
      @include ft(32);
      @include lh(50);
      @include pb(24);
      font-family: ArialMT;
    }
    .textContent {
      @include mt(25);
      @include ft(28);
      @include lh(40);
      color: #c6d9de;

      img {
        @include wh(686, 322);
        @include mt(25);
        @include mb(25);
      }
    }

    .btn {
      @include wh(536, 80);
      @include ft(32);
      @include lh(32);
      @include vc;
      margin: auto;
      border: 1px solid rgba(127, 191, 255, 0.1);
      background: linear-gradient(180deg, #27426a 0%, #4f76a3 100%)
        rgba(39, 66, 106, 0.5);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #e4eff2;
      position: fixed;
      left: 50%;
      transform: translateX(-50%);
    }

    .others {
      @include mt(60);
      @include ft(28);
    }
  }
}

@media screen and (orientation: portrait) {
  .details {
    .top {
      display: none;
    }
    .content {
      @include pd(67, 32);
      .textContent {
        img {
          @include wh(686, 322);
        }
      }
      .btn {
        bottom: len(50);
      }
      .others {
        @include wh(686, 0);
        .othersT {
          @include mt(20);
        }
      }
    }
  }
}

@media screen and (orientation: landscape) {
  #app {
    margin-left: 0 !important;
  }

  //横板
  .details {
    @include pb(145);

    .content {
      @include pd(15, 80);
      .textContent {
        img {
          @include wh(960, 451);
          // width: 100%;
          // height: auto;
        }
      }
      .btn {
        bottom: len2(50);
      }
      .others {
        @include wh(1286, 0);
        .othersT {
          @include mt(20);
        }
      }
    }
  }
}
</style>
